exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tb{margin:20px 20px 20px 20px;border-spacing:0;border-collapse:collapse}.tb thead tr,.tb tbody tr{padding:0;margin:0}.tb thead td,.tb tbody td{padding:3px 10px 3px 10px;border:1px solid #ddd}\n", ""]);

// exports
